module.exports = __webpack_public_path__ + "img/nodatas.b0d29b5b.png";